export type ReviewSource = "Google" | "Trustoo" | "VerhuisOffertes" | "Facebook";

export type ReviewType = "Particuliere verhuizing" | "Zakelijke verhuizing" | "Seniorenverhuizing" | "Verhuislift" | "Transport";

export type Review = {
  name: string;
  place?: string;
  rating: 1 | 2 | 3 | 4 | 5;
  text: string;
  source: ReviewSource;
  date?: string;
  /** Type verhuizing waar de review over gaat. */
  type?: ReviewType;
};

/**
 * ECHTE REVIEWS
 * ------------------------------------------------------------------
 * Alle onderstaande reviews zijn letterlijk overgenomen van de openbare
 * profielen van Vakkundig Verhuizingen & Transport op Trustoo (inclusief
 * de daar getoonde Google-reviews) en VerhuisOffertes. Er staat niets in
 * deze lijst dat niet ook op die platformen te vinden is.
 */
export const reviews: Review[] = [
  {
    name: "Marjan Kommer",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "Google",
    date: "2026-08-15",
    text: "Zeer ervaren verhuizers. Net werk geleverd en zeer vriendelijk.",
  },
  {
    name: "Marcel Hoyer",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "Google",
    date: "2026-08-07",
    text: "Top Verhuizers. Zeer fijn team van verhuizers. Aanrader!",
  },
  {
    name: "Loek Sanders",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "Google",
    date: "2026-08-07",
    text: "Super nice & fun people and everything handled with care! Can 100% recommend Vakkundig Verhuizen!",
  },
  {
    name: "Janneke van de Geijn",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "Google",
    date: "2026-08-07",
    text: "Communicatie vooraf verliep goed. De 4 heren waren netjes. Alles werd netjes en goed ingepakt en gesealed. De heren zijn langer gebleven en hebben alles netjes afgehandeld. Een aanrader! Bedankt heren!",
  },
  {
    name: "Krijn",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-06-29",
    text: "Het gehele traject, van offerte tot uitvoering tot factuur, getuigde van professionaliteit. Deze mannen, die zich allemaal voorstelden, zijn voorzichtiger op mijn spullen dan ik zelf ben. Er was humor, er werd gelachen en ondertussen keihard gewerkt. De prijs-kwaliteitverhouding is perfect.",
  },
  {
    name: "Wiena",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-06-08",
    text: "Heel de verhuizing prima geregeld. Vriendelijke mannen die heel behulpzaam waren en goed werkten. Mijn dressoir verhuizen lukte niet met de lift die in het appartement aanwezig was. 2 dagen later was het keurig geregeld, er kwam een auto met een lift en het was geregeld.",
  },
  {
    name: "Dennis",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-06-05",
    text: "Vriendelijke medewerkers, goede prijs/kwaliteitsverhouding. Tevreden klant.",
  },
  {
    name: "Agnes",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-05-21",
    text: "Alles is op tijd, zoals afgesproken en vakkundig verlopen. Geen onverwachte kosten wat ik ontzettend kan waarderen.",
  },
  {
    name: "Lily",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-05-23",
    text: "Snel en vakkundig. Fijne mensen en goede samenwerking.",
  },
  {
    name: "Evert Jan",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-05-08",
    text: "Optimaal. Top! En zeer sympathieke verhuizers.",
  },
  {
    name: "Wilfried",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-04-25",
    text: "Met zorg verhuisd, tevreden.",
  },
  {
    name: "Stephania",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "VerhuisOffertes",
    date: "2026-04-14",
    text: "Ben behandeld als klant is koning.",
  },
  {
    name: "Gadellaa",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "Trustoo",
    date: "2026-06-18",
    text: "Meegaand en vriendelijk.",
  },
  {
    name: "Gelauff",
    type: "Particuliere verhuizing",
    rating: 5,
    source: "Trustoo",
    date: "2026-03-07",
    text: "De verhuizing ging efficiënt en sympathieke werknemers.",
  },
  {
    name: "Ilse van den Berg",
    type: "Particuliere verhuizing",
    rating: 4,
    source: "Trustoo",
    date: "2026-04-11",
    text: "Vriendelijk. Werken snel en secuur. Ik was heel blij met ze.",
  },
  {
    name: "Wilma",
    type: "Particuliere verhuizing",
    rating: 4,
    source: "VerhuisOffertes",
    date: "2026-06-20",
    text: "Prettige verhuizers. Kwaliteit en service uitstekend.",
  },
];

/**
 * Gemiddelde score zoals die op Trustoo staat: 4,9 uit 507 reviews
 * verzameld uit drie bronnen (Google, Trustoo en VerhuisOffertes).
 */
export const reviewSummary: { rating: number; count: number } | null = {
  rating: 4.9,
  count: 507,
};

/** Openbare reviewprofielen, zodat bezoekers alles bij de bron kunnen nalezen. */
export const reviewPlatforms = [
  {
    name: "Trustoo",
    score: "9,9",
    count: "507 reviews",
    note: "Top Pro sinds 2023",
    url: "https://trustoo.nl/zuid-holland/den-haag/verhuisbedrijf/vakkundig-verhuizingen-transport-/",
  },
  {
    name: "VerhuisOffertes",
    score: "9,7",
    count: "226 reviews",
    note: "Kwaliteit 9,7 · Service 9,8",
    url: "https://www.verhuisoffertes.com/verhuizers/ee4nz/vakkundig-verhuizingen-transport/",
  },
  {
    name: "Google",
    score: "Reviews",
    count: "Bekijk op Google",
    note: "Recensies in ons bedrijfsprofiel",
    url: "https://g.co/kgs/orQ3rC7",
  },
  {
    name: "Sirelo",
    score: "Reviews",
    count: "Onafhankelijk platform",
    note: "Verhuisbedrijf Den Haag",
    url: "https://sirelo.nl/verhuisbedrijf/den-haag/vakkundig-verhuizingen-transport/",
  },
] as const;
